import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      document
          .querySelectorAll( '[data-component="horizontal-cards"]' )
          .forEach( ( component ) => {
            component.querySelectorAll( '.horizontal-cards__squiggle path' ).forEach( ( path ) => {
              const length = path.getTotalLength();

              gsap.set( path, {
                strokeDasharray: length,
                strokeDashoffset: length,
              } );

              gsap.to( path, {
                strokeDashoffset: 0,
                duration: 2.5,
                ease: 'power2.out',
                scrollTrigger: {
                  trigger: path,
                  start: 'top 75%',
                  once: true,
                },
              } );
            } );
          } );
    },

    finalize: function() {},
  };

  app.registerComponent( 'horizontal-cards', COMPONENT );
} )( app );
